import type { ReactNode } from 'react';
import { cn } from '../../utils/cn';

const toneClasses = {
  neutral: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  success: 'bg-pulse-100 text-pulse-800 dark:bg-pulse-900/40 dark:text-pulse-300',
  warning: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  danger: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
} as const;

export function Badge({ tone = 'neutral', children }: { tone?: keyof typeof toneClasses; children: ReactNode }) {
  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', toneClasses[tone])}>
      {children}
    </span>
  );
}
